'use client';

import { useSessionListVersion } from '@/components/layout/Navigation/sessions/hooks/useSessionListVersion';
import ConsolidatedSessionsBar from '@/features/consolidatedSessionsList/components/sessionBar';
import SessionsBarV2 from '@/features/upcomingSessionTab/components/session-bar-v2';
import { memo } from 'react';
import SessionsBar from '../../../sessions/side-bar';

/**
 * Wrapper component that renders the appropriate sessions sidebar, following
 * the shared useSessionListVersion variant selection (same as
 * SessionsBarContent and the mobile SessionsPanelContent).
 *
 * Uses direct imports (no lazy loading) to match EvidenceContentLoader pattern
 * for instant panel opening. Loading states are handled internally by each component.
 */
export const SessionsContentLoader = memo(function SessionsContentLoader() {
  const sessionListVersion = useSessionListVersion();

  if (sessionListVersion === 'consolidated') {
    return <ConsolidatedSessionsBar />;
  }
  if (sessionListVersion === 'v2') {
    return <SessionsBarV2 />;
  }
  return <SessionsBar />;
});
